/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-21 14:18:59
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/IconStyle/index.tsx
 */

import React from 'react';

//import css from './css.less';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { useDispatch } from 'react-redux';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { store } from 'src/store';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getIconStyle,
  onCollapseOpen,
  onErrorChange,
  onIconStyleChange,
} from '../slice';
const IconStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const { colour } = data;
  const _d = useDispatch();
  const handleOnColorChange = (colour) => {
    _d(onIconStyleChange({ colour }));
  };

  return (
    <React.Fragment>
      <Section>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.iconColour')}
          bottomTitle={getI18n(
            'salesChannelContent.index.searchiconmultilanguageicon',
          )}>
          <ColorPicker multi color={colour} onChange={handleOnColorChange} />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};

export default ErrorProcessingHOC(IconStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onIconStyleChange({ colour: '#000000' }));
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
  },
  id: EnumCollapseId.iconStyle,
  getContent: getIconStyle,
  title: getI18nFromGeneral('general.hOCTitle.iconStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
